import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

// Line-by-line masked reveal using variants (reliable on-load + on-scroll).
export const MaskText = ({ lines = [], className = "", delay = 0, once = true }) => {
  const container = {
    hidden: {},
    show: { transition: { staggerChildren: 0.1, delayChildren: delay } },
  };
  const child = {
    hidden: { y: "112%" },
    show: { y: "0%", transition: { duration: 1, ease: EASE } },
  };
  return (
    <motion.span
      className={className}
      variants={container}
      initial="hidden"
      whileInView="show"
      viewport={{ once, margin: "-8% 0px" }}
    >
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span className="block" variants={child}>
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

// Simple fade + rise on scroll into view.
export const FadeIn = ({ children, className = "", delay = 0, y = 40, once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);
